import { useSelector } from 'react-redux';
import { Col, Divider, Row } from 'antd';
import { cloneDeep, maxBy } from 'es-toolkit';

import { getLocalDateTime } from '@/utils/date';

import Button from '../../../../../components/Buttons/Button';
import PreClaimsNotesCard from '../../../PreClaims/components/CreateTabs/Tabs/Notes/PreClaimsNotesCard';

const CreateLADNotes = ({ notes, setNotes }) => {
  const user = useSelector((state) => state.auth.user?.data);
  const setEditMode = (index, val) => {
    const notesLocal = cloneDeep(notes);
    notesLocal[index].editMode = val;
    setNotes(notesLocal);
  };

  const handleAddNew = () => {
    let notesLocal = cloneDeep(notes);
    let nextSequence = maxBy(notesLocal, ({ sequenceNo }) => Number(sequenceNo));
    nextSequence = nextSequence ? nextSequence.sequenceNo : 0;
    notesLocal = [
      {
        commentText: undefined,
        commentType: undefined,
        dirtyFlag: 'i',
        editMode: true,
        isNew: true,
        oldCommentType: null,
        sequenceNo: nextSequence + 1,
      },
      ...notesLocal,
    ];
    setNotes(notesLocal);
  };

  const handleCancel = (index, isNew) => {
    const notesLocal = cloneDeep(notes);
    if (isNew) {
      notesLocal.splice(index, 1);
    } else {
      notesLocal[index] = {
        ...notesLocal[index],
        editMode: false,
      };
    }
    setNotes(notesLocal);
  };

  const handleSubmit = (data, index) => {
    const itemsL = cloneDeep(notes);
    itemsL[index] = {
      ...data,
      createdByUser: `${user?.firstName} ${user?.lastName}`,
      createdOn: getLocalDateTime().toISOString(),
      dirtyFlag: 'i',
      editMode: false,
      isNew: false,
    };
    setNotes(itemsL);
  };

  const handleDelete = (index) => {
    const itemsL = cloneDeep(notes);
    itemsL.splice(index, 1);
    setNotes(itemsL);
  };

  return (
    <div className="d-flex flex-direction-column h-100 overflow-hidden">
      <Row className="align-items-center px-15" justify="space-between">
        <Col />
        <Col>
          <Row justify="end" gutter={16}>
            <Col>
              <Button onClick={handleAddNew}>Add New Note</Button>
            </Col>
          </Row>
        </Col>
      </Row>
      <Divider className="mt-0 my-16 ml-n16 vw-100 " />
      <div className="flex-1 custom-scroll-bar">
        <div className="px-15">
          {notes.map((row, index) => (
            <PreClaimsNotesCard
              noteDetails={row}
              key={row.sequenceNo}
              index={index}
              editMode={Boolean(row.editMode)}
              setEditMode={setEditMode}
              handleCancel={handleCancel}
              handleSubmit={handleSubmit}
              handleDelete={handleDelete}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CreateLADNotes;
